<div class="row">
  <div class="row">
    <div class="col s12 range-container">
      <lms-range [config]="rangeConfig"></lms-range>
    </div>
    <div class="col s12 m6">
      <div class="greylight border-grey radius-small">
        <lms-chart
          class="wrap-content-half block padding"
          [charType]="'pie'"
          [data]="data"
          [labels]="labels"
          [colors]="colors"
          [legendColorClasses]="legendColorClasses"
          [legend]="false"
          [options]="chartOptions"
        ></lms-chart>
      </div>
    </div>
    <div class="col s12 m6">
      <div class="greylight border-grey radius-small">
        <div class="wrap-content-half block padding">
          <div class="block-charts-container">
            <div _ngcontent-c13="" class="dashboard-data">
              <div _ngcontent-c13="" class="dashboard-data-title">
                {{ 'reports.finishRatio' | translate }}
              </div>
              <div _ngcontent-c13="" class="dashboard-data-info" *ngIf="shouldShowRatio">{{ ratioFinished }} %</div>
              <div _ngcontent-c13="" class="dashboard-data-info" *ngIf="!shouldShowRatio">
                {{ 'licenses.state.notAvailable' | translate }}
              </div>
            </div>
            <div _ngcontent-c13="" class="dashboard-data" *ngIf="group.hasBonus">
              <div _ngcontent-c13="" class="dashboard-data-title">
                {{ 'reports.bonusStudents' | translate }}
              </div>
              <div _ngcontent-c13="" class="dashboard-data-info">{{ bonusedStudents }} ({{ ratioBonused }}%)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <lms-toolbar [options]="toolbarConfig"></lms-toolbar>
  <lms-licenses-activity-list
    [listId]="listId"
    [courseId]="group.customizationId"
    [group]="group"
    [course]="course"
    [shouldShowStatus]="shouldShowRatio"
    [options]="listOptions"
    (hideSearch)="setToolbarTable($event)"
  ></lms-licenses-activity-list>
</div>
